import {keyCodes} from '../../../utility/js/utils';

export default class BulkDownload {
    classList = {
        hidden: 'hidden',
        error: 'error',
        eventDisabled: 'event-disabled',
        show: 'js--show',
        loader: 'js--loader',
        jsHidden: 'js--hidden',
        aheadOfPrint: 'aheadOfPrint',
        sectionHeader: 'section__header',
        issueItem: 'issue-item',
        moved: 'js--moved',
        focusCycleWrapper: 'js--focusCycleWrapper',
    };

    selectors = {
        section: '.bulk-download',
        wrappers: '.bulkDownloadWrapper',
        modal: '.bulk-download-modal',
        modalHeader: '.modal__header',
        modalActiveBody: '.js--show[data-wizard-box]',
        modalActiveFooter: '.js--show[data-wizard-footer]',
        maxPdfElement: '[data-max-pdf]',
        hasPdfElement: '[data-has-pdf="true"]',
        bulkDownloadOption: '.bulk-download-option',
        pdfDownloadTargetOption: '.bulk-download-option[data-target="#pdfDownload"]',
        bulkDownloadInput: '.bulkDownloadInput',
        bulkWizard: '.bulk-wizard',
        exportCitationsSubmitButton: '.export-citations__submit',
        pdfDownloadSubmitButton: '.pdfDownload__submit',
        exportCitationsForm: '.exportCitationsForm',
        exportCitationInner: '.exportCitationInner',
        focusableElements:
            'a, button, input:not([type="hidden"]), textarea, select, details, [tabindex]:not([tabindex="-1"])',
        focusOrderElement: '[data-focus-order]',
        bulkFocusableEl: '.js--bulkFocusableEl',
        anchorTags: ".bulk-download [href='#'],.modal__footer [href='#']",
        bulkCheckbox: ".bulk-content input[type='checkbox']",
        cancelBtn: '.modal__footer-left a',
        closeBtn: '.bulk-download-modal .modal__header .close',
        nextBtn: '.exportCitationsForm',
        lastOption: '.exportCitationInner .bulk-content:last-child input',
    };

    elements = {
        section: null,
        wrappers: null,
        modal: null,
        maxPdfElement: null,
        hasPdfElement: null,
        bulkDownloadOption: null,
        pdfDownloadTargetOption: null,
        bulkDownloadInput: null,
        bulkWizard: null,
        exportCitationsSubmitButton: null,
        pdfDownloadSubmitButton: null,
        exportCitationsForm: null,
        currentWizardBox: null,
        currentWizardFooter: null,
        exportCitationInner: null,
        focusableList: null,
        anchorTags: null,
        bulkCheckbox: null,
        cancelBtn: null,
        closeBtn: null,
        nextBtn: null,
    };

    setElements() {
        this.elements.wrappers = document.querySelectorAll(this.selectors.wrappers);
        this.elements.modal = document.querySelector(this.selectors.modal);
        this.elements.maxPdfElement = this.elements.section.querySelector(this.selectors.maxPdfElement);
        this.elements.hasPdfElement = document.querySelectorAll(this.selectors.hasPdfElement);
        this.elements.bulkDownloadOption = document.querySelectorAll(this.selectors.bulkDownloadOption);
        this.elements.pdfDownloadTargetOption = document.querySelector(this.selectors.pdfDownloadTargetOption);
        this.elements.bulkDownloadInput = document.querySelectorAll(this.selectors.bulkDownloadInput);
        this.elements.bulkWizard = this.elements.modal.querySelectorAll(this.selectors.bulkWizard);
        this.elements.exportCitationsSubmitButton = this.elements.modal.querySelector(
            this.selectors.exportCitationsSubmitButton
        );
        this.elements.pdfDownloadSubmitButton = this.elements.modal.querySelector(
            this.selectors.pdfDownloadSubmitButton
        );
        this.elements.exportCitationsForm = this.elements.modal.querySelector(this.selectors.exportCitationsForm);
        this.elements.currentWizardBox = this.elements.modal.querySelector(`.${this.classList.show}[data-wizard-box]`);
        this.elements.currentWizardFooter = this.elements.modal.querySelector(
            `.${this.classList.show}[data-wizard-footer]`
        );
        this.elements.exportCitationInner = this.elements.modal.querySelectorAll(this.selectors.exportCitationInner);
        this.elements.anchorTags = document.querySelectorAll(this.selectors.anchorTags);
        this.elements.bulkCheckbox = document.querySelectorAll(this.selectors.bulkCheckbox);
        this.elements.cancelBtn = document.querySelector(this.selectors.cancelBtn);
        this.elements.closeBtn = document.querySelector(this.selectors.closeBtn);
        this.elements.nextBtn = document.querySelector(this.selectors.nextBtn);
    }

    constructor() {
        this.init();
    }

    init() {
        const bulkDownload = document.querySelector('.bulk-download');
        if (!bulkDownload) return;
        this.elements.section = bulkDownload;

        this.removeOldModal();
        this.setElements();
        this.initConfig();
        this.onReady();
        this.eventListeners();
    }

    removeOldModal() {
        document.querySelector(`${this.selectors.modal}.${this.classList.moved}`)?.remove();
    }

    setContentTypeText() {
        switch (this.contentType) {
            case 'articles':
                this.contentTypeText = 'articles';
                break;
            case 'articlesAndChapters':
                this.contentTypeText = 'articles/chapters';
                break;
        }
    }

    initConfig() {
        this.contentType = this.elements.section.dataset.contentType || '';
        this.contentTypeText = '';
        this.isPdf = '';
        this.maxPdfItems = this.elements.maxPdfElement ? parseInt(this.elements.maxPdfElement.dataset.maxPdf) : 0;
        this.articleNum = 0;
        this.pdfAccessNum = 0;
        this.isPdfAccessNote = false;
        this.setContentTypeText();
    }

    onReady() {
        if (!this.elements.modal.classList.contains(this.classList.moved)) {
            document.body.appendChild(this.elements.modal);
            this.elements.modal.classList.add(this.classList.moved);
        }

        this.clearModalContent();

        if (this.elements.hasPdfElement.length) {
            this.elements.hasPdfElement.forEach(item => {
                let isFull = item.nextElementSibling.innerHTML.indexOf('full'),
                    isFree = item.nextElementSibling.innerHTML.indexOf('free'),
                    isOpenAccess = item.nextElementSibling.innerHTML.indexOf('oa');

                if (!isFull && !isFree && !isOpenAccess) {
                    this.elements.pdfDownloadTargetOption.classList.remove(this.classList.hidden);
                }
            });
        }

        if (this.elements.bulkDownloadInput.length) {
            this.elements.section.classList.remove(this.classList.jsHidden);
        }
    }

    eventListeners() {
        this.elements.bulkDownloadOption.forEach(option =>
            option.addEventListener('click', this.downloadOptionHandler)
        );

        this.elements.modal.addEventListener('change', this.bulkInputHandler);

        this.elements.bulkWizard.forEach(wizard => wizard.addEventListener('click', this.wizardHandler));

        this.elements.exportCitationsSubmitButton.addEventListener('click', this.exportCitationsSubmitButton);

        this.elements.exportCitationsForm.addEventListener('click', this.collectContentHandler);

        this.elements.anchorTags?.forEach(tag => {
            tag.addEventListener('click', e => {
                e.preventDefault();
                return false;
            });
        });

        if (this.elements.pdfDownloadSubmitButton)
            this.elements.pdfDownloadSubmitButton.addEventListener('click', this.pdfDownloadSubmit);
    }

    clearModalContent = () => this.elements.exportCitationInner.forEach(inner => (inner.innerHTML = ''));

    optionKeydownHandler = () => {
        this.elements.bulkCheckbox = document.querySelectorAll(this.selectors.bulkCheckbox);
        this.elements.bulkCheckbox?.forEach(checkbox => {
            checkbox.addEventListener('keydown', e => {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    checkbox.click();
                }
            });
        });
    };

    downloadOptionHandler = e => {
        const thisEl = e.currentTarget,
            dataTarget = thisEl.dataset.target,
            targetModal = this.elements.modal.querySelector(dataTarget);

        targetModal.setAttribute('tabindex', '-1');

        let targetModalBody,
            headerContent = '',
            doiContent = '',
            bulkContent = '',
            modalContent = '',
            pdfAccessText = '';

        switch (dataTarget) {
            case '#exportCitation':
                this.isPdf = false;
                targetModalBody = targetModal.querySelector('.exportCitationWrapper');
                break;
            case '#pdfDownload':
                this.isPdf = true;
                targetModalBody = targetModal.querySelector('.pdfDownloadWrapper');
                break;
        }

        this.pdfAccessNum = 0;

        let isBulkContent = targetModalBody.querySelector('.bulk-content');

        if (this.elements.wrappers.length && !isBulkContent) {
            this.articleNum = 0;

            this.elements.wrappers.forEach(wrapper => {
                if (wrapper.classList.contains(this.classList.aheadOfPrint)) {
                    let wrapperChildren = Array.from(wrapper.children);

                    wrapperChildren.forEach(item => {
                        if (item.classList.contains(this.classList.sectionHeader)) {
                            let itemTitle = item.textContent;
                            bulkContent += `<h5 class="bulk-content__header">${itemTitle}</h5>`;
                        } else if (item.classList.contains(this.classList.issueItem)) {
                            doiContent = this.doiRender(item.querySelector('.bulkDownloadInput'), doiContent);
                            bulkContent += doiContent;
                            doiContent = '';
                        }
                    });
                } else {
                    let itemHeader = wrapper.querySelector('.section__header');
                    headerContent = itemHeader ? `<h5 class="bulk-content__header">${itemHeader.textContent}</h5>` : '';
                    doiContent = '';

                    let wrapperInputs = wrapper.querySelectorAll('.bulkDownloadInput');

                    wrapperInputs.forEach(input => (doiContent = this.doiRender(input, doiContent)));

                    bulkContent += `
                        <div class="bulk-content">
                            ${headerContent}
                            ${doiContent}
                        </div>`;
                }
            });

            if (this.isPdf) {
                if (this.pdfAccessNum < this.articleNum) {
                    if (this.articleNum <= this.maxPdfItems) {
                        this.isPdfAccessNote = true;
                        pdfAccessText = `
                            <div>
                                <div>You only have access to download <b>${this.pdfAccessNum}</b> of the <b>${this.articleNum}</b> ${this.contentTypeText} in this list.</div>
                            </div>`;
                    } else if (this.articleNum > this.maxPdfItems) {
                        this.isPdfAccessNote = true;
                        pdfAccessText = `
                            <div>
                                <div><b>This issue contains a large number of articles.</b> Please select up to ${this.maxPdfItems} items for download.</div>
                                <div>You only have access to download <b>${this.pdfAccessNum}</b> of the <b>${this.articleNum}</b> ${this.contentTypeText} in this list.</div>
                            </div>`;
                    }
                } else if (this.pdfAccessNum >= this.articleNum) {
                    if (this.pdfAccessNum > this.maxPdfItems) {
                        this.isPdfAccessNote = true;
                        pdfAccessText = `
                            <div>
                                <div><b>This issue contains a large number of articles.</b> Please select up to ${this.maxPdfItems} items for download.</div>
                            </div>`;
                    }
                }

                if (this.isPdfAccessNote) {
                    pdfAccessText = `
                        <div class="pdfAccessNote">
                            <i aria-hidden="true" class="icon-info2"></i>
                            ${pdfAccessText}
                        </div>`;
                }

                this.isPdfAccessNote = false;
            }

            modalContent += pdfAccessText;
            modalContent += bulkContent;

            if (!targetModalBody.children.length) {
                targetModalBody.innerHTML = modalContent;
                this.focusCycle(true);
            }

            let contDetails = targetModal.querySelector('.selection-count__details');
            contDetails.innerHTML = `0 of ${this.articleNum} ${this.contentTypeText}`;
            this.optionKeydownHandler();
        }
    };

    bulkInputHandler = e => {
        if (e.target.name === 'bulkDownload') {
            const thisEl = e.target,
                mainWrapper = thisEl.closest('.modal__dialog'),
                checkedInputs = mainWrapper.querySelectorAll(`[name="${thisEl.name}"]:checked`),
                pdfMaxLimit = mainWrapper.querySelector('.pdfMaxLimit'),
                selectionCount = mainWrapper.querySelector('.selection-count'),
                selectionCountIcon = selectionCount.querySelector('.selection-count__icon'),
                selectionCountReached = selectionCount.querySelector('.selection-count__reached'),
                selectionCountDetails = selectionCount.querySelector('.selection-count__details'),
                pdfMaxLimitText =
                    '<div class="pdfMaxLimit"><b>Item limit reached.</b> Please deselect another choice.</div>';

            let relatedButton = thisEl.closest('.pdfDownloadWrapper')
                ? mainWrapper.querySelector('.pdfDownload__submit')
                : mainWrapper.querySelector('.exportCitationsForm');

            if (checkedInputs.length >= 1) {
                if (!relatedButton.classList.contains(this.classList.loader)) {
                    if (relatedButton.tagName === 'A') {
                        relatedButton.classList.remove(this.classList.eventDisabled);
                    }
                    relatedButton.removeAttribute('disabled');
                }

                if (thisEl.closest('.pdfDownloadWrapper')) {
                    if (pdfMaxLimit) {
                        pdfMaxLimit.parentElement.removeChild(pdfMaxLimit);
                    }

                    if (checkedInputs.length > this.maxPdfItems) {
                        thisEl.checked = false;
                        thisEl.closest('.bulkDownloadCheckbox').insertAdjacentHTML('afterend', pdfMaxLimitText);
                        selectionCount.classList.add(this.classList.error);
                        selectionCountDetails.innerHTML = `<b>${checkedInputs.length - 1} of ${this.articleNum}</b> ${
                            this.contentTypeText
                        }`;
                    } else if (checkedInputs.length === this.maxPdfItems) {
                        selectionCount.classList.add(this.classList.error);
                        selectionCountReached.classList.remove(this.classList.hidden);
                    } else if (checkedInputs.length < this.maxPdfItems) {
                        selectionCountReached.classList.add(this.classList.hidden);
                        selectionCountIcon.classList.add(this.classList.hidden);
                        selectionCount.classList.remove(this.classList.error);
                    }
                } else {
                    selectionCount.classList.remove(this.classList.error);
                    selectionCountIcon.classList.add(this.classList.hidden);
                }
            } else {
                if (!relatedButton.classList.contains(this.classList.loader)) {
                    if (relatedButton.tagName === 'A') {
                        relatedButton.classList.add(this.classList.eventDisabled);
                    }
                    relatedButton.setAttribute('disabled', 'false');
                }
                selectionCount.classList.add(this.classList.error);
                selectionCountIcon.classList.remove(this.classList.hidden);
            }
            this.focusCycle(false);
            if (selectionCountDetails) {
                selectionCountDetails.innerHTML = `<b>${checkedInputs.length} of ${this.articleNum}</b> ${this.contentTypeText}`;
            }
        }
    };

    wizardHandler = e => {
        const thisEl = e.currentTarget,
            wizardData = thisEl.dataset.wizard,
            targetWizardBox = this.elements.modal.querySelector(`[data-wizard-box="${wizardData}"]`),
            targetWizardFooter = this.elements.modal.querySelector(`[data-wizard-footer="${wizardData}"]`);

        this.elements.currentWizardBox.classList.remove(this.classList.show);
        targetWizardBox.classList.add(this.classList.show);
        this.elements.currentWizardFooter.classList.remove(this.classList.show);
        targetWizardFooter.classList.add(this.classList.show);

        this.elements.currentWizardBox = targetWizardBox;
        this.elements.currentWizardFooter = targetWizardFooter;
        this.focusCycle(true);
    };

    collectContent = (selectedCheckBoxes, formEl) => {
        const collectedContentEl = formEl.querySelector('.collectContent'),
            collectContentNum = formEl.querySelector('.collectContentNum');

        let contentCounter = 0,
            multiText = '';

        collectedContentEl.textContent = '';
        collectContentNum.textContent = '';

        selectedCheckBoxes.forEach(doi => {
            const doiInput = `<input type="hidden" name="doi" value="${doi.value}"/>`;
            collectedContentEl.insertAdjacentHTML('beforeend', doiInput);
            contentCounter++;
        });

        multiText = contentCounter > 1 ? 's' : '';
        collectContentNum.innerHTML = `<p>You have chosen to export <span>${contentCounter}</span> citation${multiText}.</p>`;
    };

    doiRender = (item, doiContent) => {
        const firstChildTitleEl =
                item.nextElementSibling.firstElementChild ||
                item.nextElementSibling.nextElementSibling.firstElementChild,
            hasMathjax = firstChildTitleEl?.querySelectorAll('.MathJax , math , .fallback__mathEquation').length > 0,
            hasSmallCaps = firstChildTitleEl?.querySelectorAll('.smallCaps').length > 0,
            input = item.querySelector('[type="hidden"]'),
            isHasPdf = input.dataset.hasPdf === 'true';

        let accessType = item.querySelector('.hidden').textContent.trim(),
            accessClass = '',
            accessOption = true,
            isDisabled = false,
            title = '';
        hasMathjax || hasSmallCaps ? (title = firstChildTitleEl?.innerHTML) : (title = firstChildTitleEl?.textContent);
        switch (accessType) {
            case 'full':
                accessType = 'full access';
                accessClass = 'full-access';
                break;
            case 'free':
                accessType = 'free access';
                accessClass = 'free-access';
                break;
            case 'oa':
                accessType = 'open access';
                accessClass = 'open-access';
                break;
            case 'freeToRead':
                accessType = 'Free to Read';
                accessClass = 'free-to-read-access';
                isDisabled = true;
                break;
            case 'limited':
                accessType = 'token access';
                accessClass = 'token-access';
                /* eslint-disable */
                accessOption = false;
                /* eslint-enable */
                isDisabled = true;
                break;
            default:
                accessType = '';
                isDisabled = true;
                break;
        }

        doiContent += `
            <div class="bulk-content__article">
            ${
                accessType !== ''
                    ? `
                <div class="bulk-content__access-type ${accessClass}">
                    <i aria-hidden="true" class="icon-icon-lock_open"></i>
                    <span class="small">${accessType}</span>
                </div>`
                    : ``
            }
                <div class="bulk-content__details">
                    <div class="input-group bulkDownloadCheckbox${
                        (isDisabled || !isHasPdf) && this.isPdf ? ` disabled-content` : ``
                    }">
                        <label class="checkbox--primary">
                            <input title="title" type="checkbox" name="bulkDownload" value="${input.value}" ${
            (isDisabled || !isHasPdf) && this.isPdf ? `disabled` : ``
        }>
                            <span class="label-txt">
                                <div class="bulk-content__title">${title}</div>
                            </span>
                        </label>
                    </div>
                </div>
            </div>`;

        if (isHasPdf && !isDisabled) {
            this.pdfAccessNum++;
        }
        this.articleNum++;
        return doiContent;
    };

    collectContentHandler = e => {
        const targetedWrapper = this.elements.modal.querySelector(e.currentTarget.dataset.wrapper),
            targetedForm = this.elements.modal.querySelector(e.currentTarget.dataset.form),
            selectedCheckBoxes = targetedWrapper.querySelectorAll('[name="bulkDownload"]:checked');

        this.collectContent(selectedCheckBoxes, targetedForm);
    };

    exportCitationsSubmitButton = e => {
        e.preventDefault();
        const thisEl = e.currentTarget,
            submitTargetedForm = this.elements.modal.querySelector(thisEl.dataset.form);

        submitTargetedForm.submit();
    };

    pdfDownloadSubmit = e => {
        const thisEl = e.currentTarget,
            innerSpan = thisEl.querySelector('span'),
            AjaxData = this.elements.section.querySelector('[data-target="#pdfDownload"]').dataset.ajax,
            mainWrapper = thisEl.closest('.modal__dialog'),
            checkedInputs = mainWrapper.querySelectorAll('[name="bulkDownload"]:checked'),
            errorMessageEl = thisEl.previousElementSibling.querySelector('.selection-count__error');

        let inputsContent = '',
            inputsCounter = 0;

        e.preventDefault();
        errorMessageEl.classList.add(this.classList.hidden);
        thisEl.setAttribute('disabled', true);
        thisEl.classList.add(this.classList.loader);
        thisEl.classList.add(this.classList.eventDisabled);
        innerSpan.textContent = 'Preparing download';

        checkedInputs.forEach(input => {
            if (inputsCounter === 0) {
                inputsContent += '?';
            }
            inputsContent += `doi=${input.value}&`;
            inputsCounter++;
        });
        inputsContent = AjaxData + inputsContent.slice(0, -1);

        fetch(inputsContent)
            .then(response => response)
            .then(data => {
                switch (data.headers.get('download-status')) {
                    case 'full_access': {
                        const fileName = data.headers.get('content-disposition').replace('attachment; filename=', '');
                        data.blob().then(blob => {
                            const a = document.createElement('a'),
                                url = window.URL.createObjectURL(blob);

                            a.href = url;
                            a.download = fileName;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                        });
                        break;
                    }
                    default:
                        this.downloadButtonErrorReset(errorMessageEl, data.headers.get('download-status'));
                }
                this.resetDownloadButton(thisEl, innerSpan);
            })
            .catch(error => {
                console.log(error); // eslint-disable-line no-console
            });
    };

    resetDownloadButton = (button, inner) => {
        button.removeAttribute('disabled');
        button.classList.remove(this.classList.loader);
        button.classList.remove(this.classList.eventDisabled);
        inner.textContent = 'Download (.zip)';
    };

    downloadButtonErrorReset = (el, messageType = '') => {
        let errorMessageText = '';
        switch (messageType) {
            case 'partial_access':
                errorMessageText = 'You do not have a required license. Some publications cannot be downloaded.';
                break;
            case 'no_access':
                errorMessageText = 'You do not have the required license. No publication will be downloaded.';
                break;
            default:
                errorMessageText = 'Something went wrong, Please try again later.';
                break;
        }

        el.classList.remove(this.classList.hidden);
        el.textContent = errorMessageText;
    };

    focusCycle = focusReset => {
        const currentFocusOrderElement = this.elements.modal.querySelectorAll(this.selectors.focusOrderElement);

        currentFocusOrderElement.forEach(item => item.removeAttribute('data-focus-order'));

        this.elements.focusableList = this.focusableElements;
        this.elements.focusableList.forEach((item, index) => {
            item.dataset.focusOrder = index;
            item.addEventListener('focusout', this.focusCycleHandler);
        });
        [
            this.elements.cancelBtn,
            this.elements.nextBtn,
            this.elements.closeBtn,
            this.elements.exportCitationsSubmitButton,
        ].forEach(item => item.addEventListener('keydown', this.focusTrapHandler));
    };

    focusTrapHandler = e => {
        if (!e.shiftKey && e.keyCode === keyCodes.TAB) {
            if (
                (e.target === this.elements.cancelBtn && this.elements.nextBtn.disabled) ||
                e.target === this.elements.nextBtn ||
                e.target === this.elements.exportCitationsSubmitButton
            ) {
                e.preventDefault();
                this.elements.closeBtn.focus();
            } else if (e.target === this.elements.cancelBtn) {
                e.preventDefault();
                this.elements.nextBtn.focus();
            }
        }
        if (e.shiftKey && e.keyCode === keyCodes.TAB) {
            if (
                (e.target === this.elements.closeBtn && this.elements.nextBtn.disabled) ||
                e.target === this.elements.nextBtn
            ) {
                e.preventDefault();
                this.elements.cancelBtn.focus();
            } else if (e.target === this.elements.closeBtn) {
                e.preventDefault();
                if (this.elements.nextBtn.closest('.js--show')) {
                    this.elements.nextBtn.focus();
                }
                if (this.elements.exportCitationsSubmitButton.closest('.js--show')) {
                    this.elements.exportCitationsSubmitButton.focus();
                }
            } else if (e.target === this.elements.cancelBtn) {
                e.preventDefault();
                document.querySelector(this.selectors.lastOption)?.focus();
            }
        }
    };

    focusCycleHandler = e => {
        e.stopImmediatePropagation();
        const focusOrder = e.target.dataset.focusOrder;
        if (e.relatedTarget && !e.relatedTarget.closest(this.selectors.modal)) {
            switch (focusOrder) {
                case '0':
                    this.elements.focusableList[this.elements.focusableList.length - 1].focus();
                    break;
                case `${this.elements.focusableList.length - 1}`:
                    this.elements.focusableList[0].focus();
                    break;
            }
        }
    };

    get focusableElements() {
        const focusableList = [];
        this.elements.modal
            .querySelectorAll(`${this.selectors.modalHeader}, .${this.classList.show}[data-wizard-footer]`)
            .forEach(item => {
                item.querySelectorAll(this.selectors.focusableElements).forEach(el => {
                    if (!el.disabled) focusableList.push(el);
                });
            });
        return focusableList;
    }
}
